import md from 'markdown-it'
import markdownItFigureCaption from '../../../lib/markdown-it/imageWithCaption'

const customizeImageTag = (html: string): string => {
  if (html.includes('<img')) {
    html = html.replaceAll('<img', '<img class="mx-auto max-h-36" ')
  }
  return html
}

export const HeadingAndText = ({text, heading}: any) => {

  let renderedText = md().use(markdownItFigureCaption).render(text)
  renderedText = customizeImageTag(renderedText)
  
  return (
    <section className='mt-8 mb-8'>
      {heading && <h2 className='text-2xl text-heresy-primary'>{heading}</h2>}
      <div className='prose prose-invert lg:prose-xl' dangerouslySetInnerHTML={{ __html: renderedText }}/>
    </section>);
}
